import socket from "../utils/clientSocket";
import React, { useEffect, useState } from "react";
import AcceptDenyModal from "./AcceptDenyModal";

const EndGameModal = () => {
    const [drawOffered, setDrawOffered] = useState(null)

    useEffect(() => {
        socket.on('offerDraw', () => {
            setDrawOffered(true)
        })
    }, []);

    const forfeitGame = () => {
        socket.emit('forfeit')
    }

    const proposeDraw = () => {
        socket.emit('offerDraw')
    }

    const acceptDraw = () => {
        socket.emit('acceptDraw')
        setDrawOffered(false)
    }

    const denyDraw = () => {
        setDrawOffered(false)
    }

    return (
        <div className="box" style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
                <button
                    className="give-up-btn"
                    onClick={forfeitGame}
                >
                    Give Up
                </button>
                <button
                    className="suggest-draw-btn"
                    onClick={proposeDraw}
                >
                    Suggest Draw
                </button>
            </div>
            {drawOffered && (
                <AcceptDenyModal statement={"A draw has been offered. Accept?"} acceptCallback={acceptDraw}
                                 denyCallback={denyDraw} closeCallback={() => setDrawOffered(false)}/>
            )}
        </div>
    );
}

export default EndGameModal;